﻿/**
 * @author Mamatha siripi
 * @dashBoard Consent Template - New Registration
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APITemplateService } from '../../_services/template/API-template'; 
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';


//below code for Current Data
const now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
	selector: 'app-consent-new-registration',
	templateUrl: './consent-new-registration.component.html',
	styleUrls: ['./consent-new-registration.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class ConsentRegComponent implements OnInit {
	email: any;
	mobileno: any;
	response: any;
	entityId: any //Vijay
	consentForm: FormGroup;
	isValid:boolean=false;
	templateIds:Number[]=[];
	UrnNum:any;
	includesvar: boolean = false;
	entityName: any;

	constructor(private fb: FormBuilder,
		private es: APITemplateService,
		private ls: APIEntityService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.entityId = params['urn'] //Vijay- time being getting entity id from urn 
			this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID); //Vijay - need to get entity id from session instead of URN
			this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
		})
	}
	
	get f() { return this.consentForm.controls; }


	ngOnInit() {
		this.consentForm = this.fb.group({
			entity_id: ['',],
			industry_category: ['',],
			org_name: ['',],
			// contemp_id: ['', [Validators.required]],
			unique_name: ['', [Validators.required]],
			brand_name: ['',[Validators.required,Validators.maxLength(50)]],
			consent_content: ['', [Validators.maxLength(1000),Validators.required,Validators.pattern('^(?! ).*(?<! )$')]],
		});
		this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		this.getContentEntityDetails(this.entityId) //Vijay- to get entity details from DLT
	//	this.getTemplatesByPE() //Vijay- templates registered by pe
		//this.getDiabledFieldsData(); 
	}//end of oninit
	
	//Vijay- to get entity details from DLT 
	getContentEntityDetails(entityId) {
		let data = {  
		  "entity_id": entityId,     
		}
		this.ls.getContentEntityDetails(data)
		  .subscribe(r => {
			this.consentForm.controls['entity_id'].setValue(r[0].id);  
			this.consentForm.controls['entity_id'].disable();   
			this.UrnNum=r[0].id;

			// if(r[0].etype ==='P') {     
			// 	this.consentForm.controls['industry_category'].setValue('private');
			// 	this.consentForm.controls['industry_category'].disable();  
			// } else if(r[0].etype =='G') {
			// 	this.consentForm.controls['industry_category'].setValue('Government');
			// 	this.consentForm.controls['industry_category'].disable();  
			// }      
			


			switch(r[0].etype){
				case 'P':
					this.consentForm.controls['industry_category'].setValue('Private');
					break;
				case 'G':
					this.consentForm.controls['industry_category'].setValue('Government');
					break;
				case 'S':
					this.consentForm.controls['industry_category'].setValue('SEBI');
					break;
				case 'U':
					this.consentForm.controls['industry_category'].setValue('Public Limited Company');
					break;
				case 'O':
					this.consentForm.controls['industry_category'].setValue('Others');
					break;
				default:
					this.consentForm.controls['industry_category'].setValue('');
					break;
			} 

			this.consentForm.controls['org_name'].setValue(r[0].name);
			this.consentForm.controls['org_name'].disable();  
		})
	}
	//Vijay- templates registered by pe
	// getTemplatesByPE() {   
	// 	let query = {  
	// 		Entity_ID: this.entityId, 
	// 		"Template_Status": "A"
	// 	}
	// 	this.es.getTemplateSummaryMongo(query)      
	// 	.subscribe(r => {
	// 		for(let i=0;i<=r.length-1;i++){
	// 			this.templateIds.push(r[i].Template_ID);

	// 		}
	// 		console.log("getTemplatesByPE ",r);
	// 		console.log("getTemplatesByPE ",this.templateIds);

	// 	}); 
	// }

	// getDiabledFieldsData for diabled fileds
	getDiabledFieldsData() {
		this.ls.GetNewConsentTemplate(this.entityId).subscribe(result => { 
			console.log("new data " + result);
			this.onChangeDataSource(result);
		})
	}
	omit_special_char(e) {

		var k;
		document.all ? k = e.keyCode : k = e.which;
		return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k == 109) || (k == 189)|| (k == 95) || (k == 45)|| (k >= 48 && k <= 57));
	}

   isSpecCheckadres:boolean=false;
   isSpecCheckadresName:boolean=false;
   noWhitespaceValidator(control) {
	if((control.value.toLowerCase()).includes('{#var#}')){
		this.includesvar = true;
	} else {
		this.includesvar  = false;
	}
	if (control.value.startsWith(' ')) {
		if(control.id == 'consent_content'){
		this.isSpecCheckadres=true;
		}else{
			this.isSpecCheckadresName=true;
		}
	  }else
	  if (control.value.endsWith(' ')) {
		if(control.id == 'consent_content'){
			this.isSpecCheckadres=true; 
			}else{
				this.isSpecCheckadresName=true;  
			}
		
	  }if(isNaN(control.value)=== false){
		if(control.id == 'unique_name'){
		this.isSpecCheckadresName=true;
		} 
	  }
		  else{
			if(control.id == 'consent_content'){

		this.isSpecCheckadres=false;
			}else{
		this.isSpecCheckadresName=false;
			}

	  }
	
	
}
   
	onChangeDataSource(res) {
	   this.UrnNum=res.message.Entity_ID;
		this.consentForm.controls['entity_id'].setValue(res.message.Entity_ID)
		this.consentForm.controls['industry_category'].setValue(res.message.Industry_Cat)
		this.consentForm.controls['org_name'].setValue(res.message.Entity_OrganizationName)
	}
	reset(){
		//this.getDiabledFieldsData();
		this.router.navigateByUrl('/entity-consent-template-report');

	}
	//for Form submition
	onSubmit() {

		if (this.consentForm.invalid) {
			let invalid = [];
			let controls = this.consentForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					invalid.push(name);
				}
			}
			return;
		}
		if(this.isSpecCheckadres || this.isSpecCheckadresName || this.includesvar){
			return;
		}
		this.EntityRegistartion();

	}


	EntityRegistartion() {
		let Entity_ID = this.consentForm.get("entity_id").value;
		let Industry_Cat = this.consentForm.get("industry_category").value;
		let Entity_OrganizationName = this.consentForm.get("org_name").value;
		// let Content_TemplateIDs = this.consentForm.get("contemp_id").value;
		let CST_Name = this.consentForm.get("unique_name").value;
		let CST_Brand = this.consentForm.get("brand_name").value;
		let CST_Content = this.consentForm.get("consent_content").value;

		// const consentForm = new FormData();
		// consentForm.append('Entity_ID', Entity_ID);
		// consentForm.append('Industry_Cat', Industry_Cat);
		// consentForm.append('Entity_OrganizationName', Entity_OrganizationName);
		// consentForm.append('Content_TemplateIDs', Content_TemplateIDs);
		// consentForm.append('CST_Name', CST_Name);
		// consentForm.append('CST_Brand', CST_Brand);
		// consentForm.append('CST_Content', CST_Content);
		// consentForm.append('Entity_Class', "PE");

		// consentForm.append('CST_CreatedDate', currentdat);
		let consentForm ={ 
			'Entity_ID':Entity_ID,
			'Industry_Cat':Industry_Cat,
			'Entity_OrganizationName':Entity_OrganizationName,
		//	'Content_TemplateIDs':Content_TemplateIDs,
			'CST_Name':CST_Name,
			'CST_Brand':CST_Brand,
			'CST_Content':CST_Content,
			'Entity_Class':CST_Content,
			'CST_CreatedDate':currentdat

		}
		this.ls.newConsentTemplate(consentForm)
			.subscribe(r => {
				console.log(r)
				if (r.status == "success") {
					//this.showSumbit = false
					this.$modal.successModal({
						title: 'Consent Template - New Registration',
						msg: 'Your request for consent template registration has been submitted successfully. URN-'+r.insertInMongo.CST_RefNo
					}) 
					this.isValid=true;
					this.consentForm.reset();
					this.getContentEntityDetails(this.entityId);
					//this.router.navigateByUrl('/')

				}
				else{
					if (r.message) {
						//this.showSumbit = false
						this.$modal.errorModal({                                                                                                                                                                            
							title: 'Consent Template - New Registration',
							msg: r.message
						}) 
				}                                                     
			
				else {
					this.$modal.errorModal({                                                                                                                                                                                                
						title: 'Consent Template - New Registration',
						msg: 'Error updating New Registration!'
					})
				}                                                              
			}
				// console.log(r);
				// try {
				// 	if (r.status) {
				// 		this.$modal.errorModal({
				// 			title: 'Consent Template - New Registration',
				// 			msg: 'Your data sumbitted successfully. Would you like to complete registration process now?'
				// 		});
				// 	}
				// }
				// catch (e) {
				// 	console.log("catch in registration", e);
				// }
			});
	}
}